import { formatTableData, getData } from '../utils/formatters';

interface SantaCruzData {
  address?: string;
  city?: string;
  parcelId?: string;
  parcelNumber?: string;
  ownerName?: string;
  ownerMailingAddress?: string;
  acres?: string | number;
  zone?: string;
  zoningCode?: string;
  zoningLabel?: string;
  legalDescription?: string;
  section?: string;
  township?: string;
  range?: string;
  taxCode?: string;
  floodplain?: string;
  platMapUrl?: string;
}

const SANTA_CRUZ_ROWS = [
  {
    label: 'Address',
    getValue: (data: SantaCruzData) => getData(data, 'address', 'No address available')
  },
  {
    label: 'City',
    getValue: (data: SantaCruzData) => getData(data, 'city', 'No city available')
  },
  {
    label: 'Parcel ID',
    getValue: (data: SantaCruzData) => getData(data, 'parcelId', 'No parcel ID available')
  },
  {
    label: 'Owner',
    getValue: (data: SantaCruzData) => getData(data, 'ownerName', 'No owner information available')
  },
  {
    label: 'Owner Mailing Address',
    getValue: (data: SantaCruzData) =>
      getData(data, 'ownerMailingAddress', 'No owner mailing address available')
  },
  {
    label: 'Property Size',
    getValue: (data: SantaCruzData) => {
      const acres = data.acres;
      if (acres === undefined || acres === null || acres === '') {
        return 'No property size information available';
      }
      return `${acres} acres`;
    }
  },
  {
    label: 'Zone',
    getValue: (data: SantaCruzData) => {
      if (data.zone) {
        return String(data.zone);
      }
      const label = data.zoningLabel;
      const code = data.zoningCode;
      if (label) {
        return code && code !== label ? `${code} - ${label}` : label;
      }
      if (code) {
        return String(code);
      }
      return 'No zoning information available';
    }
  },
  {
    label: 'Legal Description',
    getValue: (data: SantaCruzData) =>
      getData(data, 'legalDescription', 'No legal description available')
  },
  {
    label: 'Section / Township / Range',
    getValue: (data: SantaCruzData) => {
      const parts = [data.section, data.township, data.range].filter(Boolean);
      if (parts.length === 0) {
        return 'No section / township / range available';
      }
      return parts.join(' / ');
    }
  },
  {
    label: 'Tax Area',
    getValue: (data: SantaCruzData) => getData(data, 'taxCode', 'No tax area available')
  },
  {
    label: 'Floodplain',
    getValue: (data: SantaCruzData) =>
      getData(data, 'floodplain', 'No floodplain information available')
  },
  {
    label: 'Plat Map',
    getValue: (data: SantaCruzData) => {
      if (data.platMapUrl) {
        return `[View Plat Map](${data.platMapUrl})`;
      }
      return 'No plat map available';
    }
  }
];

export const formatSantaCruzData = (data: SantaCruzData): string => {
  return formatTableData(data, SANTA_CRUZ_ROWS);
};
